import React from "react";
import { StyleRules, withStyles, WithStyles } from "@material-ui/core/styles";

const IMAGE_WIDTH = 300;
const IMAGE_HEIGHT = 114;

const styles: StyleRules = {
  image: {
    width: "100%"
  }
};

interface ImageProps extends WithStyles<typeof styles> {
  imageUrl: string;
}

interface HTMLImageAttributes<T> extends React.ImgHTMLAttributes<T> {
  loading?: "lazy" | "eager" | "auto";
}

const Image: React.FC<HTMLImageAttributes<HTMLElement>> = props => (
  <img {...props} alt={props.alt} />
);

const BasicTipImage: React.FC<ImageProps> = ({ classes, imageUrl }) => (
  <Image
    loading="lazy"
    alt=""
    role="presentation"
    src={imageUrl}
    width={IMAGE_WIDTH}
    height={IMAGE_HEIGHT}
    className={classes.image}
  />
);

export const TipImage = withStyles(styles)(BasicTipImage);
